module.exports = __webpack_public_path__ + "static/media/auth-bg.1342d4da.png";